"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNonEmpty = isNonEmpty;
function isNonEmpty(items) {
    return items.length > 0;
}
//# sourceMappingURL=isNonEmpty.js.map